const getters = {
  userId: state => state.app.userId,
  theme: state => state.app.theme,
  moduleName: state => state.app.moduleName,
  module: state => state.app.module,
  info: state => state.app.info,
  userInfo: state => state.app.userInfo
}
export default getters
